export default {
  "da": {
    "header": "for platforms",
    "sub_header": "ONLINECITY.IO skubber grænsen for avancerede men brugervenlige platforme!",
    "paragraph_1": "Vi elsker platforme, og vi elsker at løfte vores kunder til nye højder ved at skabe høj effektivitet og sammenhæng via vores platforme.",
    "paragraph_2": "Vores team arbejder benhårdt på at skabe de bedst mulige oplevelser, hvad enten det gælder interfaces, support eller nye features.",
    "bot_desc": "Artificial CEO"
  },
  "en": {
    "header": "for platforms",
    "sub_header": "ONLINECITY.IO boosts the standard for advanced but easy to use platforms!",
    "paragraph_1": "We love platforms and we love to catapult our customers to new heights through our platforms.",
    "paragraph_2": "Our team members focus on creating the best possible experience, whether it be interfaces, support or new features.",
    "bot_desc": "Artificial CEO"
  },
}



// WEBPACK FOOTER //
// ./src/multilanguage/passion.js